import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'byId',
    standalone: false,
})
export class ByIdPipe implements PipeTransform {
    transform<T>(value: T[], id: number | string, idField = 'id'): T {
        return value?.find(p => p[idField] === id);
    }
}
